import { h } from "omi";

import { IconProps } from "@/wc/components";

export function FileQuestionIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
      <path
        d="M16.6663 7.91699v-2.25c0-1.40013 0-2.10019-.2724-2.63497-.2397-.47041-.6222-.85286-1.0926-1.09254-.5348-.27249-1.2348-.27249-2.635-.27249H7.33301c-1.40013 0-2.1002 0-2.63498.27249-.4704.23968-.85286.62213-1.09254 1.09254-.27248.53478-.27248 1.23484-.27248 2.63497v8.66671c0 1.4001 0 2.1002.27248 2.6349.23968.4704.62214.8529 1.09254 1.0926.53478.2725 1.23485.2725 2.63498.2725h4.33329m0-9.16671H6.66634m1.66667 3.33331H6.66634M13.333 5.83366H6.66634m7.08336 6.66854c.1468-.4174.4366-.7694.8181-.9936.3815-.2242.83-.3061 1.2661-.2313.4361.0748.8316.3015 1.1166.64.2849.3385.4409.767.4402 1.2094 0 1.2491-1.8736 1.8736-1.8736 1.8736m.0242 2.5h.0083"
        stroke="currentColor"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
